<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-15 17:48:31
 * @FilePath: 
 * @Description:拼团商品详情页面
-->
<template>
  <div>
    <g-swiper
      :images="activeInfo.goodsBanners"
      prefix="imgUrl"
      :cusStyle="cusStyle"
    ></g-swiper>

    <div class="content c-p-20">
      <div class="title_con">
        <div class="group_num_con">2人成团</div>
        <p>{{ activeInfo.Name }}</p>
      </div>
      <div class="c-fl-bt content-top">
        <div>
          <span class="c-yang c-tc" v-if="activeInfo.MarketPrice">￥</span>
          <span class="c-money c-p-r-10" v-if="activeInfo.MarketPrice">{{
            activeInfo.MarketPrice
          }}</span>
          <b class="c-sub-money" v-if="activeInfo.ScribePrice">
            <span class="">￥</span>{{ activeInfo.ScribePrice }}
          </b>
          <span class="is-sale">已拼{{ activeInfo.Sales }}</span>
        </div>
        <div class="add-box">
          <div class="add-r">
            <div class="l" @click="goodsNumHandler('delete')">
              <g-img
                :src="require('@/assets/images/reduce_icon.png')"
                :size="50"
              ></g-img>
            </div>
            <div class="c">
              {{ this.goodsNum }}
            </div>
            <div class="r" @click="goodsNumHandler('add')">
              <g-img
                :src="require('@/assets/images/add_icon_active.png')"
                :size="50"
              ></g-img>
            </div>
          </div>
        </div>
      </div>

      <div class="add-box c-p-20" v-if="isCanBuy"></div>
    </div>
    <g-line></g-line>
    <goods-img-com
      :textInduction="activeInfo.Induction"
      :imgInfo="activeInfo.introImgs"
    ></goods-img-com>
    <div class="footer">
      <div class="font-34">
        <van-icon name="like-o" />
        <span class="m-l-5">收藏</span>
      </div>
      <div>
        <van-button
          :disabled="!isCanBuy"
          color="var(--tc)"
          round
          @click="immediatelyBuy"
          style="margin-right: 10px"
        >
          <p>￥{{ allOriginPrice }}</p>
          <p>直接购买</p>
        </van-button>
        <van-button
          :disabled="!isCanBuy"
          color="var(--tc)"
          round
          @click="immediatelyBuy"
        >
          <p>￥{{ allPrice }}</p>
          <p>发起拼单</p></van-button
        >
      </div>

      <!-- <p class="dark-btn" @click="placeOrder"
      v-if="keyBindMode !== 'ManualInputByWaiter' || handCode">{{ wechatPointPayMode === 'CyBillWithPad' ? '呼叫服务员' : '提交订单' }}</p> -->
    </div>
  </div>
</template>

<script>
import { getProductDetail } from "@/api/goods";
import { submitOrder } from "@/api/order";
import { isDuringDate } from "@/utils/index";
import goodsImgCom from "@/components/goodsImgCom";
export default {
  name: "GroupBuyPage",
  props: {},
  components: {
    goodsImgCom,
  },
  data() {
    return {
      productId: "299792501",
      cusStyle: {
        height: "300px",
        // width: '375px',
      },
      allOriginPrice: 0,
      goodsNum: 1,
      activeInfo: {},
      isShowEmpty: false,
      isOnSale: true,
      isWeChatClient: true,
      userId: "", // 用户id，微信内置浏览器为openid，其他环境为系统的userId
    };
  },
  computed: {
    isCanBuy() {
      return this.activeInfo.StatusMsg == "活动进行中";
    },
    allPrice() {
      this.allOriginPrice = this.activeInfo.ScribePrice * this.goodsNum;
      return this.activeInfo.MarketPrice * this.goodsNum;
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      // 判断浏览器环境
      const browserType = this.$store.state.browserType;
      if (browserType.shell === "wechat") {
        this.userId = localStorage.getItem("OpenId");
      } else {
        this.isWeChatClient = false;
      }
      // 获取产品详情
      // getProductDetail({ query: { id: this.productId } }).then((res) => {
      //   if (res.Pager.TotalCount > 0) {
      const res = {
        Items: [
          {
            StatusMsg: "活动进行中",
            Name: "这是商品名称",
            MarketPrice: 9,
            ScribePrice: 45,
            Sales: 100,
            IsAllowRefund: true,
            Claims: [
              {
                TypeId: 1,
                CdnUrl: "",
                Value: "",
              },
              {
                TypeId: 2,
                CdnUrl: require("@/assets/goods_detail_imgs/1.jpg"),
                Value: "",
              },
              {
                TypeId: 2,
                CdnUrl: require("@/assets/goods_detail_imgs/2.jpg"),
                Value: "",
              },
              {
                TypeId: 2,
                CdnUrl: require("@/assets/goods_detail_imgs/3.jpg"),
                Value: "",
              },
              {
                TypeId: 2,
                CdnUrl: require("@/assets/goods_detail_imgs/4.jpg"),
                Value: "",
              },
              {
                TypeId: 2,
                CdnUrl: require("@/assets/goods_detail_imgs/5.jpg"),
                Value: "",
              },
            ],
            Induction: "这是商品描述",
            SecondsNum: "2022-07-15T12:05:56",
            SecondsNumBeforeBeginTime: "2022-07-15T09:05:56",
          },
        ],
      };
      const data = res.Items[0];
      // 产品简介
      // data.shortIntros = []
      // 产品图片
      data.goodsBanners = [];
      data.introImgs = [];

      const imgArr = data.Claims;
      if (imgArr instanceof Array && imgArr.length > 0) {
        imgArr.map((item) => {
          if (item.TypeId === 0) {
            data.goodsImgUrl = `${item.CdnUrl}/${item.Value}`;
          }
          // if (item.TypeId === 1) {
          // data.goodsBanners.push({
          //   imgUrl: `${item.CdnUrl}/${item.Value}`,
          // });
          // }
          if (item.TypeId === 2) {
            // data.introImgs.push({ imgUrl: `${item.CdnUrl}/${item.Value}` });
            data.introImgs.push({ imgUrl: `${item.CdnUrl}` });
            data.goodsBanners.push({
              imgUrl: `${item.CdnUrl}`,
            });
          }
        });
      }
      // 产品有效期
      // if (data.IsAbsoluteExpirationDate) {
      //   // 绝对日期
      //   data.goodsValidTime = `${data.ExpirationStartDate}至${data.ExpirationEndDate}`;
      // } else {
      //   // 相对日期
      //   data.goodsValidTime = `自购买日起${data.ExpirationDays}天内有效`;
      // }
      // // 产品的销售日期
      // this.isOnSale = isDuringDate(
      //   data.SaleStartDate || "1990-1-1",
      //   data.SaleEndDate || "2099-12-31"
      // );
      // data.SalesTime = `${data.SaleStartDate}至${data.SaleEndDate}`;
      // // 产品优惠金额
      // if (data.MarketPrice > data.CostPrice) {
      //   // data.discountAmount = (data.MarketPrice - data.CostPrice).toFixed(2)
      // }
      this.activeInfo = data;
      //   } else {
      //     this.isShowEmpty = true;
      //   }
      // });
    },
    async immediatelyBuy() {
      // let data = this.activeInfo;
      // const goodsInfo = {
      //   imgUrl: data.goodsImgUrl,
      //   id: data.Id,
      //   name: data.Name,
      //   price: data.CostPrice,
      //   validTime: data.goodsValidTime,
      //   number: this.goodsNum,
      //   tenantId: data.TenantId,
      // };
      // this.$pub.setS("goodsInfo", goodsInfo);
      this.onSubmit();
    },
    async onSubmit() {
      // this.$pub.setS("pageBeforeLogin", "submitOrder");
      // this.goodsInfo = this.$pub.getS("goodsInfo");
      // const requestParams = {
      //   Phone: this.$pub.getS("userPhone") || this.$store.state.OpenId,
      //   VpnId: this.$store.state.vpnId,
      //   Items: [
      //     {
      //       DistributorId: localStorage.getItem("distributorId"),
      //       ProductId: this.goodsInfo.id,
      //       Quantity: this.goodsInfo.number,
      //     },
      //   ],
      // };
      // const orderId = await submitOrder(requestParams);
      // this.$store.commit("setStoreVal", { orderId: orderId });
      this.$router.push({
        name: "PayList",
        query: { id: "9999", fromPage: "groupBuy" },
      });
    },

    goodsNumHandler(handle, v, i) {
      if (handle === "add") {
        this.goodsNum++;
      }
      if (handle === "delete") {
        if (this.goodsNum === 1) {
          return this.$toast("购买数量不得低于1张");
        }
        this.goodsNum--;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 750px;
  box-sizing: border-box;
  background: #ffffff;
  z-index: 1000;
  position: relative;
}
.sale-price {
  font-size: 48px;
  font-weight: bold;
  font-family: Cochin-Bold, Cochin;
  color: var(--tc);
  margin-right: 10px;
}
.yang {
  color: var(--tc);
}
.is-sale {
  font-size: 24px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #888888;
}
.content-top {
  margin: 10px 0;
}
.title_con {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  display: flex;
  align-items: center;
  .group_num_con {
    font-size: 20px;
    color: #fff;
    background: #e71f19;
    padding: 5px 10px;
    margin-right: 20px;
  }
}
.add-box {
  display: flex;
  .add-r {
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .c {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 100px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
</style>
